module.exports = __webpack_public_path__ + "img/HOT-STAR.d2b98289.svg";